module.exports = __webpack_public_path__ + "03_short_black.ac595e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_short_black.png
// module id = d+6Q
// module chunks = 0